
import { motion } from 'framer-motion';

const Achievements = () => {
  const achievements = [
    {
      year: '2024',
      title: 'Literary Excellence Award',
      organization: 'National Book Foundation',
      description: 'Recognized for outstanding contribution to contemporary fiction',
    },
    {
      year: '2023',
      title: 'Readers\' Choice Award',
      organization: 'Goodreads Community',
      description: 'Voted favorite author in literary fiction category',
    },
    {
      year: '2022',
      title: 'Distinguished Author Fellowship',
      organization: 'Leavitt Peak Press',
      description: 'Honored for exceptional literary craftsmanship and storytelling',
    },
    {
      year: '2021',
      title: 'Emerging Voice in Literature',
      organization: 'Writers\' Guild',
      description: 'Celebrated as a rising talent in contemporary narrative fiction',
    },
  ];

  return (
    <section className="py-24 px-8 lg:px-16 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="font-playfair text-5xl font-bold text-charcoal mb-6">
            Recognition & Achievements
          </h2>
          <p className="font-lato text-lg text-warm-gray max-w-3xl mx-auto">
            Honors celebrating a commitment to literary excellence and authentic storytelling
          </p>
        </motion.div>

        <div className="space-y-6">
          {achievements.map((achievement, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-light-cream rounded-xl p-8 hover:shadow-lg transition-all"
            >
              <div className="flex flex-col md:flex-row gap-6">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 flex items-center justify-center bg-burgundy rounded-lg">
                    <span className="font-playfair text-2xl font-bold text-cream">
                      {achievement.year}
                    </span>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-playfair text-2xl font-bold text-charcoal mb-2">
                    {achievement.title}
                  </h3>
                  <p className="font-lato text-sm text-burgundy mb-3 tracking-wider">
                    {achievement.organization}
                  </p>
                  <p className="font-lato text-warm-gray leading-relaxed">
                    {achievement.description}
                  </p>
                </div>
                <div className="flex-shrink-0 flex items-center">
                  <i className="ri-award-line text-4xl text-burgundy/30"></i>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
